export default function () {
    return {
        data:{},
        dataDefault: {
            id: '',
            descricao:'',
            id_banco: '',
            tabela: '',
            campo_chave:'',
            campo_exibicao: '',
            campo_busca: '',
            campo_ordem:'',
            campo_fixo: '',
            ativo: '',
            tipo_ordem: '',
            campo_codigo: '',
            master:'S'    
        },
        disableForm: false,
        dataList:[],        
        pagination:{},
        selectLookup:{}
    }
  }
  